module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/media-inquiry/MEDIAINQUIRY_01-room-brochure.png";